import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {EmbeddingDTO, PaperHasEmbeddingDTO} from '../../dto/embedding';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {loadEmbeddingsForPaper} from '../../service/embedding.actions';
import {selectPaperEmbeddings} from '../../service/embedding.selectors';
import {MatListModule} from '@angular/material/list';
import {MatCard, MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';

@Component({
  selector: 'app-paper-embedding-detail',
  imports: [
    FormsModule,
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatCardModule,
    MatExpansionModule
  ],
  templateUrl: './paper-embedding-detail.component.html',
  styleUrl: './paper-embedding-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaperEmbeddingDetailComponent {
  private readonly store: Store = inject(Store);
  private readonly dialogRef: MatDialogRef<PaperEmbeddingDetailComponent> = inject(MatDialogRef);
  readonly data: PaperHasEmbeddingDTO = inject<PaperHasEmbeddingDTO>(MAT_DIALOG_DATA);

  readonly embeddings = this.store.selectSignal(selectPaperEmbeddings(this.data.paperId));

  constructor() {
    this.store.dispatch(loadEmbeddingsForPaper({paperId: this.data.paperId}));
  }

  close(): void {
    this.dialogRef.close();
  }
}
